var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header',{staticClass:"Header"}),_c('Sidebar',[_c('router-view',{staticClass:"router-view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }